// extracted by mini-css-extract-plugin
var _1 = "Question_error__4JlTU";
var _2 = "Question_limitPhrases__ggudO";
var _3 = "768px";
var _4 = "Question_phrase__SDYmM";
var _5 = "Question_questionContainer__RyPVJ";
var _6 = "Question_questionLabel__W1Top";
var _7 = "Question_questionLabelContainer__XfYjn";
var _8 = "Question_questionSubLabel__PVTe4";
var _9 = "Question_radioColorQuestion__028Hg";
var _a = "Question_shake__C69s+";
var _b = "\"../../../shared.module.css\"";
export { _1 as "error", _2 as "limitPhrases", _3 as "md", _4 as "phrase", _5 as "questionContainer", _6 as "questionLabel", _7 as "questionLabelContainer", _8 as "questionSubLabel", _9 as "radioColorQuestion", _a as "shake", _b as "shared" }
